
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.75 18.25c-.504 0-.936-.18-1.294-.538a1.766 1.766 0 01-.54-1.295V4.5H2.75v11.917h15.583v1.833H2.75zm3.667-3.667c-.504 0-.936-.179-1.295-.538a1.766 1.766 0 01-.539-1.295V2.667c0-.504.18-.936.54-1.296.358-.358.79-.538 1.294-.538H11l1.833 1.834h6.417c.504 0 .936.18 1.295.539.36.358.538.79.538 1.294v8.25c0 .504-.179.936-.538 1.295-.359.359-.79.538-1.295.538H6.417z"}})])
          )
        }
      }
    